import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid } from 'react-bootstrap';
import FullLogo from 'components/atoms/FullLogo';
import OnMountHomeScroll from 'hoc/OnMountHomeScroll';
import breakpoint from 'styled-components-breakpoint';
import { colors } from 'services/theme/brandTheme/brandColors';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    width: 100%;
    height: 100vh;
    background-color: ${colors.goodwayBlue[50].hex};
`;

const AuthBox = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: 2.357em;
    background-color: rgba(${colors.white.rgb},1);
    box-shadow: 0 5px 13px 0 rgba(${colors.black.rgb},0.2);
    text-align: center;
    position: relative;
    border-radius: 4px;

    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 5px;
        background-image: linear-gradient(90deg,
            ${colors.sun[200].hex} 0, ${colors.sun[400].hex} 19.25%,
            ${colors.sun[400].hex} 20%, ${colors.goodwayBlue[200].hex} 39.25%,
            ${colors.goodwayBlue[200].hex} 40%, ${colors.goodwayBlue[400].hex} 59.25%,
            ${colors.goodwayBlue[400].hex} 60%, ${colors.goodwayBlue[600].hex} 79.25%,
            ${colors.goodwayBlue[600].hex} 80%, ${colors.midnightBlue[900].hex} 99.25%);
    }
`;

const AuthLogoContainer = styled.div`
    text-align: center;
    margin: 33px 0;
    display: block;
    min-width: 500px;
`;

const AuthLogoFull = styled(FullLogo)`
     ${breakpoint('sm', 'xl')`
        width: 50%;
    `}

    ${breakpoint('xs')`
        width: 65%;
    `}
`;

const AuthTemplate = ({
    children, ...props
}) => (
    <Wrapper {...props}>
        <Grid fluid>
            <AuthLogoContainer>
                {!props.hideLogo ? <AuthLogoFull></AuthLogoFull> : null}
            </AuthLogoContainer>

            <AuthBox>{children}</AuthBox>
        </Grid>
    </Wrapper>
);

AuthTemplate.propTypes = {
    children: PropTypes.any.isRequired,
};

export default OnMountHomeScroll()(AuthTemplate);



// WEBPACK FOOTER //
// ./src/components/templates/Auth.js